/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_SALES_DATA,
  LOAD_SALES_DATA_SUCCESS,
  LOAD_SALES_DATA_ERROR,
  CREATE_SALES_DATA,
  CREATE_SALES_DATA_SUCCESS,
  CREATE_SALES_DATA_ERROR,
  UPDATE_SALES_DATA,
  UPDATE_SALES_DATA_SUCCESS,
  UPDATE_SALES_DATA_ERROR,
  LOAD_BANK_DETAILS,
  LOAD_BANK_DETAILS_SUCCESS,
  LOAD_BANK_DETAILS_ERROR,
  UPDATE_EVENT_DATA,
  UPDATE_EVENT_DATA_SUCCESS,
  UPDATE_EVENT_DATA_ERROR,
  LOAD_SALES_TEMP_DATA,
  LOAD_SALES_TEMP_DATA_SUCCESS,
  LOAD_SALES_TEMP_DATA_ERROR,
  CREATE_SALES_TEMP_DATA,
  CREATE_SALES_TEMP_DATA_SUCCESS,
  CREATE_SALES_TEMP_DATA_ERROR,
  UPDATE_SALES_TEMP_DATA,
  UPDATE_SALES_TEMP_DATA_SUCCESS,
  UPDATE_SALES_TEMP_DATA_ERROR,
  DELETE_SALES_TEMP_DATA,
  DELETE_SALES_TEMP_DATA_SUCCESS,
  DELETE_SALES_TEMP_DATA_ERROR,
  APPROVE_SALES_QC_REQUEST_SUCCESS,
  APPROVE_SALES_QC_REQUEST,
  APPROVE_SALES_QC_REQUEST_ERROR,
  UPDATE_SALES_QC_REAPPROVE,
  UPDATE_SALES_QC_REAPPROVE_SUCCESS,
  UPDATE_SALES_QC_REAPPROVE_ERROR,
  LOAD_SALES_PENDING,
  LOAD_SALES_PENDING_SUCCESS,
  LOAD_SALES_PENDING_ERROR,
  LOAD_SALES_QC_HISTORY,
  LOAD_SALES_QC_HISTORY_SUCCESS,
  LOAD_SALES_QC_HISTORY_ERROR,
  BOOKING_COMPLETE,
  BOOKING_COMPLETE_SUCCESS,
  BOOKING_COMPLETE_ERROR,
  // LOAD_SALES_PREVIEW_MASTER,
  // LOAD_SALES_PREVIEW_MASTER_SUCCESS,
  // LOAD_SALES_PREVIEW_MASTER_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(salesMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    salesMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Sales
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesList(id) {
  return {
    type: LOAD_SALES_DATA,
    id,
  }
}

export function loadSalesListSuccess(sales_list) {
  return {
    type: LOAD_SALES_DATA_SUCCESS,
    sales_list,
  }
}

/**
 * @param {string} error
 */

export function loadSalesListError(error) {
  return {
    type: LOAD_SALES_DATA_ERROR,
    error,
  }
}

//Create sales details

export function createSalesRecord(salesListData) {
  console.log("record", salesListData)
  return {
    type: CREATE_SALES_DATA,
    salesListData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createSalesRecordSuccess(salesListData, success) {
  console.log("record", salesListData)
  return {
    type: CREATE_SALES_DATA_SUCCESS,
    salesListData,
    success,
  }
}

/**
 * @param {string} error
 */
export function createSalesRecordError(error) {
  return {
    type: CREATE_SALES_DATA_ERROR,
    error,
  }
}

//Update sales details

export function updateSalesRecord(salesListData) {
  console.log("record", salesListData)
  return {
    type: UPDATE_SALES_DATA,
    salesListData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateSalesRecordSuccess(salesListData, success) {
  console.log("record", salesListData)
  return {
    type: UPDATE_SALES_DATA_SUCCESS,
    salesListData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateSalesRecordError(error) {
  return {
    type: UPDATE_SALES_DATA_ERROR,
    error,
  }
}

//Update Event details

export function updateEventRecord(eventData) {
  console.log("record", eventData)
  return {
    type: UPDATE_EVENT_DATA,
    eventData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateEventRecordSuccess(eventData, success) {
  console.log("record", eventData)
  return {
    type: UPDATE_EVENT_DATA_SUCCESS,
    eventData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateEventRecordError(error) {
  return {
    type: UPDATE_EVENT_DATA_ERROR,
    error,
  }
}

//Sales
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesTempList(id) {
  return {
    type: LOAD_SALES_TEMP_DATA,
    id,
  }
}

export function loadSalesTempListSuccess(sales_payment_list) {
  return {
    type: LOAD_SALES_TEMP_DATA_SUCCESS,
    sales_payment_list,
  }
}

/**
 * @param {string} error
 */

export function loadSalesTempListError(error) {
  return {
    type: LOAD_SALES_TEMP_DATA_ERROR,
    error,
  }
}

//Create sales details

export function createSalesTempRecord(payments) {
  console.log("record", payments)
  return {
    type: CREATE_SALES_TEMP_DATA,
    payments,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createSalesTempRecordSuccess(payments, success) {
  console.log("record", payments)
  return {
    type: CREATE_SALES_TEMP_DATA_SUCCESS,
    payments,
    success,
  }
}

/**
 * @param {string} error
 */
export function createSalesTempRecordError(error) {
  return {
    type: CREATE_SALES_TEMP_DATA_ERROR,
    error,
  }
}

//Update sales details

export function updateSalesTempRecord(payments) {
  console.log("record", payments)
  return {
    type: UPDATE_SALES_TEMP_DATA,
    payments,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateSalesTempRecordSuccess(payments, success) {
  console.log("record", payments)
  return {
    type: UPDATE_SALES_TEMP_DATA_SUCCESS,
    payments,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateSalesTempRecordError(error) {
  return {
    type: UPDATE_SALES_TEMP_DATA_ERROR,
    error,
  }
}

/**
 *
 * @param {string} salesTempId
 * @returns
 */
export function deleteSalesTempRecord(salesTempId) {
  return {
    type: DELETE_SALES_TEMP_DATA,
    salesTempId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteSalesTempRecordSuccess(salesTempId, success) {
  return {
    type: DELETE_SALES_TEMP_DATA_SUCCESS,
    salesTempId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteSalesTempRecordError(error) {
  return {
    type: DELETE_SALES_TEMP_DATA_ERROR,
    error,
  }
}

//Sales
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadBankDetails(id) {
  return {
    type: LOAD_BANK_DETAILS,
    id,
  }
}

export function loadBankDetailsSuccess(bank_details) {
  return {
    type: LOAD_BANK_DETAILS_SUCCESS,
    bank_details,
  }
}

/**
 * @param {string} error
 */

export function loadBankDetailsError(error) {
  return {
    type: LOAD_BANK_DETAILS_ERROR,
    error,
  }
}

///Sales Approval list

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function approvalSalesRequestQc(id, leadQuotationId, salesId, remarks) {
  const leadId = id
  return {
    type: APPROVE_SALES_QC_REQUEST,
    leadId,
    leadQuotationId,
    salesId,
    remarks,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function approvalSalesRequestQcSuccess(
  id,
  success,
  leadQuotationId,
  salesId,
  remarks
) {
  const leadId = id

  return {
    type: APPROVE_SALES_QC_REQUEST_SUCCESS,
    leadId,
    leadQuotationId,
    salesId,
    remarks,
    success,
  }
}

/**
 * @param {string} error
 */
export function approvalSalesRequestQcError(error) {
  return {
    type: APPROVE_SALES_QC_REQUEST_ERROR,
    error,
  }
}

//Re-approve update API

/**
 *
 * @returns
 */
export function updateSalesQcReapprove(qcUpdateData) {
  return {
    type: UPDATE_SALES_QC_REAPPROVE,
    qcUpdateData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function updateSalesQcReapproveSuccess(success, qcUpdateData) {
  return {
    type: UPDATE_SALES_QC_REAPPROVE_SUCCESS,
    qcUpdateData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateSalesQcReapproveError(error) {
  return {
    type: UPDATE_SALES_QC_REAPPROVE_ERROR,
    error,
  }
}

// Load Sales Pending Approval
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesPending() {
  return {
    type: LOAD_SALES_PENDING,
  }
}

export function loadSalesPendingSuccess(sales_pending_details) {
  return {
    type: LOAD_SALES_PENDING_SUCCESS,
    sales_pending_details,
  }
}

/**
 * @param {string} error
 */

export function loadSalesPendingError(error) {
  return {
    type: LOAD_SALES_PENDING_ERROR,
    error,
  }
}

//Qc list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesQcHistory(id) {
  return {
    type: LOAD_SALES_QC_HISTORY,
    id,
  }
}

export function loadSalesQcHistorySuccess(sales_qc_history) {
  return {
    type: LOAD_SALES_QC_HISTORY_SUCCESS,
    sales_qc_history,
  }
}

/**
 * @param {string} error
 */

export function loadSalesQcHistoryError(error) {
  return {
    type: LOAD_SALES_QC_HISTORY_ERROR,
    error,
  }
}

//Booking complete
/**
 *
 * @param {integer} id
 * @returns
 */
export function bookingCompleteList(bookingComplete) {
  return {
    type: BOOKING_COMPLETE,
    bookingComplete,
  }
}

export function bookingCompleteListSuccess(bookingComplete, success) {
  return {
    type: BOOKING_COMPLETE_SUCCESS,
    bookingComplete,
    success,
  }
}
export function bookingCompleteListError(error) {
  return {
    type: BOOKING_COMPLETE_ERROR,
    error,
  }
}

// export function loadSalesLayoutSegment() {
//   return {
//     type: LOAD_SALES_PREVIEW_SEGMENT,
//   }
// }

// export function loadSalesLayoutSegmentSuccess(sales_layout_segment) {
//   return {
//     type: LOAD_SALES_PREVIEW_SEGMENT_SUCCESS,
//     sales_layout_segment,
//   }
// }

// export function loadSalesLayoutSegmentError(error) {
//   return {
//     type: LOAD_SALES_PREVIEW_SEGMENT_ERROR,
//     error,
//   }
// }

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadSalesList,
  loadSalesListSuccess,
  loadSalesListError,
  createSalesRecord,
  createSalesRecordSuccess,
  createSalesRecordError,

  updateSalesRecord,
  updateSalesRecordSuccess,
  updateSalesRecordError,

  updateEventRecord,
  updateEventRecordSuccess,
  updateEventRecordError,

  loadSalesTempList,
  loadSalesTempListSuccess,
  loadSalesTempListError,
  createSalesTempRecord,
  createSalesTempRecordSuccess,
  createSalesTempRecordError,

  updateSalesTempRecord,
  updateSalesTempRecordSuccess,
  updateSalesTempRecordError,

  deleteSalesTempRecord,
  deleteSalesTempRecordSuccess,
  deleteSalesTempRecordError,

  loadBankDetails,
  loadBankDetailsSuccess,
  loadBankDetailsError,

  //sales approve
  approvalSalesRequestQc,
  approvalSalesRequestQcError,
  approvalSalesRequestQcSuccess,

  updateSalesQcReapprove,
  updateSalesQcReapproveSuccess,
  updateSalesQcReapproveError,
  loadSalesPending,
  loadSalesPendingSuccess,
  loadSalesPendingError,
  loadSalesQcHistory,
  loadSalesQcHistorySuccess,
  loadSalesQcHistoryError,

  bookingCompleteList,
  bookingCompleteListSuccess,
  bookingCompleteListError,

  // loadSalesLayoutSegment,
  // loadSalesLayoutSegmentSuccess,
  // loadSalesLayoutSegmentError,
}

export default actions
